import { useEffect } from "react";

export const Analytics = () => {
  useEffect(() => {
    const CONSENT_KEY = "ins_cookie_consent";
    const hasConsent = (() => {
      try {
        const raw = localStorage.getItem(CONSENT_KEY);
        if (!raw) return false;
        const parsed = JSON.parse(raw);
        return Boolean(parsed.analytics);
      } catch {
        return false;
      }
    })();

    const loadPlausible = () => {
      if (document.getElementById("plausible-script")) return;
      const script = document.createElement("script");
      script.id = "plausible-script";
      script.setAttribute("defer", "");
      script.setAttribute("data-domain", "insorganizasyon.org");
      script.src = "https://plausible.io/js/script.js";
      document.head.appendChild(script);
    };

    const GA_ID = "G-Z2MXTN0RPG";
    const loadGtag = () => {
      if (!GA_ID) return;
      if (!document.getElementById("gtag-src")) {
        const gtagSrc = document.createElement("script");
        gtagSrc.id = "gtag-src";
        gtagSrc.async = true;
        gtagSrc.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
        document.head.appendChild(gtagSrc);
      }
      if (!(window as any).dataLayer) {
        (window as any).dataLayer = (window as any).dataLayer || [];
        function gtag(){ (window as any).dataLayer.push(arguments); }
        (window as any).gtag = gtag;
        (window as any).gtag('js', new Date());
        (window as any).gtag('config', GA_ID);
      }
    };

    if (hasConsent) {
      loadPlausible();
      loadGtag();
    }

    const handler = () => { loadPlausible(); loadGtag(); };
    let attached = false;
    if (!(window as any).__insAnalyticsListenerAttached) {
      window.addEventListener("ins_analytics_opt_in", handler as EventListener);
      (window as any).__insAnalyticsListenerAttached = true;
      attached = true;
    }
    return () => { if (attached) window.removeEventListener("ins_analytics_opt_in", handler as EventListener); };
  }, []);

  return null;
};
